document.documentElement.classList.remove('no-js');

document.addEventListener('change', (event) => {
  const sort = event.target.closest('[data-collection-sort]');
  if (sort) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    window.location.assign(url.toString());
    return;
  }

  const variantSelect = event.target.closest('[data-variant-select]');
  if (variantSelect) {
    const form = variantSelect.closest('form');
    const option = variantSelect.options[variantSelect.selectedIndex];
    const submit = form?.querySelector('[data-add-to-cart]');
    const price = document.querySelector('[data-product-price]');

    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (submit) {
      const available = option.dataset.available === 'true';
      submit.disabled = !available;
      submit.textContent = available ? 'Add to cart' : 'Sold out';
    }
  }
});

document.addEventListener('click', (event) => {
  const link = event.target.closest('.sff-mobile-menu__panel a');
  if (link) link.closest('details')?.removeAttribute('open');
});
